import { Component, Input, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { IxellAPIService } from '../../tools/api.service';
import { Reference } from '../../tools/api.service';
import { SearchCrit } from 'src/app/entities/searchCrit';
import { HeaderService } from 'src/app/tools/header.service';

@Component({
    selector: 'referencelist',
    templateUrl: './reference-list.component.html',
    styleUrls: ['./reference-list.component.scss']
})

export class ReferenceListComponent implements OnInit {
    @Input() references: Reference[];
    @Input() searchCrit: SearchCrit;
    @Output() variants = new EventEmitter<Reference[]>();

    private variantsSub: any;
    displayedColumns = ["manufacturer", "code", "designation", "dateFrom", "dateTo"];
    sortedResults: Reference[];

    @HostListener('window:popstate', ['$event'])
    onPopState(event: any) {
        this.headerService.changeBack(true);
    }
    ngOnInit() {

        //console.log(this.references);

        window.onpopstate = function () {
            history.go(1);
        };
        this.sortedResults = this.references.slice();
        if (this.sortedResults.length == 1)
            this.SelectReference(this.sortedResults[0]);
    }

    constructor(private apiService: IxellAPIService, private headerService: HeaderService) { }

    sortReferences(sort: Sort) {
        const isAsc = sort.direction == 'asc';
        const data = this.references.slice();
        if (!sort.active || sort.direction === '') {
            this.sortedResults = data;
            return;
        }

        this.sortedResults = data.sort((a, b) => {
            switch (sort.active) {
                case "manufacturer":
                    if (a.manufacturer == b.manufacturer) return 0;
                    return (a.manufacturer < b.manufacturer ? -1 : 1) * (isAsc ? 1 : -1);
                case "code":
                    if (a.code == b.code) return 0;
                    return (a.code < b.code ? -1 : 1) * (isAsc ? 1 : -1);
                case "designation":
                    if (a.designation == b.designation) return 0;
                    return (a.designation < b.designation ? -1 : 1) * (isAsc ? 1 : -1);
                case "dateFrom":
                    if (a.dateFrom == b.dateFrom) return 0;
                    return (a.dateFrom < b.dateFrom ? -1 : 1) * (isAsc ? 1 : -1);
                case "dateTo":
                    if (a.dateTo == b.dateTo) return 0;
                    return (a.dateTo < b.dateTo ? -1 : 1) * (isAsc ? 1 : -1);
            }
        })
    }

    SelectReference(ref: Reference) {
        this.variantsSub = this.apiService.getVariants(ref.code, ref.designation, ref.manufacturer, ref.formuleNum, ref.shadeGuideNum, ref.shadeGuideNumAlt, this.searchCrit.searchWorld, this.searchCrit.technology).subscribe(data => {
            this.variants.emit(data);
            if (this.variantsSub != null) this.variantsSub.unsubscribe();
        },
            error => {
                console.log(error);
                if (this.variantsSub != null) this.variantsSub.unsubscribe();
            });
    }

    ngOnDestroy(): void {
        if (this.variantsSub != null) this.variantsSub.unsubscribe();
    }
}
